// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.language-box {
  display: flex;
  align-items: center;
  height: 40px;
  width: 0px;
  cursor: pointer;
}

::ng-deep .modal-body {
  max-height: 70vh;
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/components/common/add-item/add-item.component.scss"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AAAJ;;AAII;EACI,gBAAA;EACA,gBAAA;AADR","sourcesContent":["\n.language-box{\n    display: flex;\n    align-items: center;\n    height: 40px;\n    width: 0px;\n    cursor: pointer;\n}\n\n::ng-deep {\n    .modal-body {\n        max-height: 70vh;\n        overflow-y: auto;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
